import historySchema from './history.schema';

/**
 * This module saves history of species death and duo events.
 *
 * Usage:
 *  History.modifiers.addDeathRecord(state, { ... });
 *  History.modifiers.addPlayerDuoRecord(state, { ... });
 *  History.getters.getHistory(...)
 */
export * as ruleset from './history.ruleset';
export * as getters from './history.getters';
export * as modifiers from './history.modifiers';

export const schema = historySchema;
